import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Default namespace and fallback
const defaultNS = 'common';
const fallbackLng = 'en';
const supportedLanguages = ['en', 'es', 'zh', 'hi', 'fr', 'pt'];

i18n
  .use(HttpBackend)
  .use(LanguageDetector) // Detecta automáticamente el idioma del navegador
  .use(initReactI18next)
  .init({
    fallbackLng,
    supportedLngs: supportedLanguages,
    defaultNS,
    ns: [defaultNS],

    // Configuración del detector de idioma
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },

    backend: {
      // TMS endpoint - update with your Locize/Crowdin URL
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

export { i18n };
